export const LOAD_CHANNELS = 'LOAD_CHANNELS';
export const LOAD_CHANNELS_SUCCESS = 'LOAD_CHANNELS_SUCCESS';
export const LOAD_CHANNELS_FAILURE = 'LOAD_CHANNELS_FAILURE';

export const ADD_CHANNEL = 'ADD_CHANNEL';
export const ADD_CHANNEL_SUCCESS = 'ADD_CHANNEL_SUCCESS';
export const ADD_CHANNEL_FAILURE = 'ADD_CHANNEL_FAILURE';

export const DEL_CHANNEL = 'DEL_CHANNEL';
export const DEL_CHANNEL_SUCCESS = 'DEL_CHANNEL_SUCCESS';
export const DEL_CHANNEL_FAILURE = 'DEL_CHANNEL_FAILURE';



// WEBPACK FOOTER //
// ./src/constants/actionTypes/channels.js